import { TbRss, TbBrandGithubFilled, TbBrandLinkedin, TbBrandYoutube, TbMail } from "react-icons/tb";
import { Link } from "react-router-dom";
import { useSetting } from "../../../contexts/settings";
import { isExternalHref } from '../../../utils/internalHref';

const Footer = () => {
  const email = useSetting("contactEmail", "me@gazar.dev");
  const socialLinks = [
    { href: useSetting("socialLinkedIn", "https://www.linkedin.com/in/gazar"), icon: TbBrandLinkedin, label: "LinkedIn" },
    { href: useSetting("socialYouTube", "https://www.youtube.com/@gazarbreakpoint"), icon: TbBrandYoutube, label: "YouTube" },
    { href: useSetting("socialGitHub", "https://github.com/ehsangazar"), icon: TbBrandGithubFilled, label: "GitHub" },
    { href: `mailto:${email}`, icon: TbMail, label: "Email" },
  ];
  return (
    <footer className="bg-brand-navy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-9 md:py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="text-h4 font-heading font-bold uppercase text-white mb-3">
              Gazar
            </h3>
            <p className="text-body-sm font-body text-white/70 leading-relaxed mb-3">
              Helping engineers take LLM and agent systems from demo to production. Courses, mentorship and cohorts from 16+ years in the trenches.
            </p>
            <p className="text-caption font-body text-white/40 leading-relaxed">
              gazar.dev is a brand and portfolio operated by <strong className="text-white/70">QUEEK LIMITED</strong>.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-body-sm font-heading font-bold uppercase tracking-[0.18em] text-white mb-3">
              Links
            </h3>
            <ul className="space-y-1">
              {[
                { to: "/about", label: "About" },
                { to: "/mentorship", label: "Mentorship" },
                { to: "/ventures", label: "Ventures" },
                { to: "/contact", label: "Contact" },
                { to: "/privacy", label: "Privacy" },
                { to: "/terms", label: "Terms" },
                { to: "/cookies", label: "Cookies" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-body-sm font-body text-white/60 hover:text-white transition-colors duration-150 inline-flex items-center py-1"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/newsletter"
                  className="text-body-sm font-body text-white/60 hover:text-white transition-colors duration-150 inline-flex items-center py-1"
                >
                  Newsletter
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-body-sm font-heading font-bold uppercase tracking-[0.18em] text-white mb-3">
              Resources
            </h3>
            <ul className="space-y-1">
              {[
                { to: "/learnings", label: "Learnings" },
                { to: "/decks", label: "Slide Decks" },
                { to: "/talks", label: "Talks" },
                { to: "/podcast", label: "Podcast" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-body-sm font-body text-white/60 hover:text-white transition-colors duration-150 inline-flex items-center py-1"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/feed.xml"
                  className="text-body-sm font-body text-white/60 hover:text-white transition-colors duration-150 inline-flex items-center gap-1.5 py-1"
                >
                  <TbRss size={14} />
                  RSS Feed
                </Link>
              </li>
            </ul>
          </div>

          {/* Social & Contact */}
          <div>
            <h3 className="text-body-sm font-heading font-bold uppercase tracking-[0.18em] text-white mb-3">
              Connect
            </h3>
            <div className="space-y-3">
              <div className="flex flex-wrap gap-2">
                {socialLinks.map((link) => {
                  const IconComponent = link.icon;
                  const isExternal = isExternalHref(link.href);
                  return (
                    <a
                      key={link.label}
                      href={link.href}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                      className="inline-flex items-center justify-center w-12 h-12 rounded-smooth bg-white/10 text-white border border-white/20 transition-colors duration-150 hover:bg-white hover:text-brand-navy hover:border-white"
                      title={link.label}
                      aria-label={link.label}
                    >
                      <IconComponent size={16} />
                    </a>
                  );
                })}
              </div>
              <div className="pt-2">
                <a
                  href={`mailto:${email}`}
                  className="text-body-sm font-body text-white/60 hover:text-white transition-colors duration-150 inline-flex items-center py-1"
                >
                  {email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-7 pt-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-caption font-body text-white/40 text-center sm:text-left">
              &copy; 2026 QUEEK LIMITED. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
